import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  bufferTime,
  catchError,
  first,
  map,
  mergeMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { Device, IOs, LiveUnitStatus, Unit } from '../models/unit';
// import { WebSocketDataService } from 'src/app/vehicles/services/webSocketData.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import * as L from 'leaflet';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  private units$: BehaviorSubject<Unit[]>;
  private unit$: BehaviorSubject<Unit>;
  public _units: Unit[] = [];
  private listGNSSIMEI: string[] = [];
  constructor(
    private http: HttpClient, // private webSocketDataService: WebSocketDataService
    private vehicleService : VehicleService
  ) {
    this.units$ = new BehaviorSubject<Unit[]>([]);
    this.unit$ = new BehaviorSubject<Unit>(this.toUnit(''));
    const initUnits = (units: any[]) => {
      this._units = units;
      this.units$.next(units);
      this.listGNSSIMEI = units.map((u: any) => u.GNSSIMEI.toString());
    };

    const connectToSocket = (units: any[]) => {
      if (!units.length) return;

      const imeis = units.map((u) => u.GNSSIMEI.toString());

      const socket = new Socket({
        url: environment.unitSocket,
        options: {
          query: {
            userId: localStorage.getItem('user_id'),
            secret: environment.secretClient,
          },
          // @ts-ignore
          withCredentials: false,
          cors: {
            origin: '*',
          },
        },
      });

      socket.connect();

      socket.on('connect', () => {
        socket.emit('set-imeis', imeis);
      });

      socket.ioSocket.on('units-data', (res: string, data: any) => {
        if (Array.isArray(res)) {
          this.units$.next(this.liveUnitStatusToUnits(res));
        }
      });
    };
    this.vehicleService.vehiclesResponse$.subscribe(data => {
      if(data.length == 0){
        return
      }
      const units = data.map((veh: any) => this.toUnit(veh));
      initUnits(units);
      connectToSocket(units);
      this.vehicleService.setVehiclesResponse([])
    })

    return;
    // if (this.vehicleService.statusDataVehicle) {
    //   const units = this.vehicleService.vehiclesResponse.map((veh: any) => this.toUnit(veh));
    //   initUnits(units);
    //   connectToSocket(units);
    //   this.vehicleService.vehiclesResponse = []
    // } else {
      
    //   this.vehicleService.dataVehicleCompleted
    //     .pipe(
    //       first(),
    //       map((data) => this.toUnits(data)),
    //       tap(initUnits)
    //     )
    //     .subscribe({
    //       next: connectToSocket,
    //       error: (err) => {
    //         console.error('Error al conectar con el socket PAXI:', err);
    //       },
    //     });
    // }
    // return;

  }

  get getUnits() {
    return this.units$.asObservable();
  }
  get getUnit() {
    return this.unit$.asObservable();
  }

  // -----API-----
  public requestUnits(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/api/tracker');
  }
  // -----Functions-----
  private liveUnitStatusToUnits(res: any[]): Unit[] {
    const _res = res
      .map((r) => {
        r.locationDate += r.locationDate.match(
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
        )
          ? '.000Z'
          : '';
        r.device.lastStartTime += r.device.lastStartTime.match(
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
        )
          ? '.000Z'
          : '';
        r.device.serverDate += r.device.serverDate.match(
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
        )
          ? '.000Z'
          : '';
        r.device.trackerDate += r.device.trackerDate.match(
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
        )
          ? '.000Z'
          : '';

        let l: LiveUnitStatus = {
          ...r,
          locationDate: new Date(r.locationDate),
          device: {
            ...r.device,
            lastStartTime: new Date(r.device.lastStartTime),
            serverDate: new Date(r.device.serverDate),
            trackerDate: new Date(r.device.trackerDate),
          },
        };
        return l;
      })
      .filter((r) => this.listGNSSIMEI.includes(r.GNSSIMEI));

    let Us: Unit[] = [...this.units$.getValue()];

    Us = Us.map((U) => {
      let u = _res.find((T) => T.GNSSIMEI == U.GNSSIMEI);
      if (u) u.device.SIMNumber = U.device.SIMNumber;
      return u ? { ...U, ...u } : { ...U };
    });

    return Us;
  }
  public toUnits(data: any): Unit[] {
    const units: Unit[] = [];
    if (Array.isArray(data)) data.map((unit) => units.push(this.toUnit(unit)));
    return units;
  }
  public toUnit(data: any): Unit {
    // console.log('unit: ', data);
    let IOs: IOs = this.parseParams(data.parametros);
    let unit: Unit = {
      recordId: this.toNumber(data.id),
      GNSSIMEI: this.toString(''),
      hasIgnition: this.checkIgnition(IOs),
      currentSpeed: this.checkSpeed(IOs),
      elapsedTime: this.getElapsedTime(this.toISO(data.dt_tracker ?? '')),
      latlngTimeElapsed: this.getElapsedTime(this.toISO(data.dt_tracker ?? '')),
      locationDate: new Date(this.toISO(data.dt_tracker ?? '')),
      device: {
        IMEI: '',
        deviceName: '',
        IOs: IOs,
        lastStartTime: new Date(),
        satelliteCount: 0,
        powerVoltage: 0,
        batteryVoltage: 0,
        batteryLevel: 0,
        latitude: 0,
        longitude: 0,
        altitude: 0,
        speed: 0,
        angle: 0,
        signalStrength: 0,
        serverDate: new Date(),
        trackerDate: new Date(this.toISO(data.dt_tracker ?? '')),
        sentRecordsCount: 0,
        actualOperatorCode: 0,
        signalLevel: 0,
        GPRSStatus: false,
        SIMStatus: false,
        SIMNumber: this.toNumber(data.sim_number),
      },
      unitType: this.toString(data.nametype_vehicle),
      unitTypeId: this.toNumber(data.tipo),
      unitModel: this.toString(data.model),
      unitChassis: this.toNumber(0),
      unitEngine: this.toString(''),
      unitBrand: this.toString(''),
      unitYear: this.toNumber(0),
      unitColor: this.toString(''),
      unitId: this.toString(data.vehicle_id),
      unitName: this.toString(data.name),
      licensePlate: this.toString(data.plate_number),
      company: this.toString(data.empresa),
      project: this.toString(''),
      idOperation: this.toNumber(data.idoperation),
      operation: this.toString(data.nameoperation),
      idGrupo: this.toNumber(data.idgrupo),
      group: this.toString(data.namegrupo),
      idConvoy: this.toNumber(data.idconvoy),
      convoy: this.toString(data.nameconvoy),
      isActive: this.toBoolean(data.active),
      internalCode: this.toString(data.cod_interno),
      fuelType: this.toString(''),
      currentFuelLevel: this.toNumber(0),
      fuelTankCapacity: this.toNumber(0),
      fuelConsumptionRate: this.toNumber(0),
      averageFuelConsumption: this.toNumber(0),
      estimatedRange: this.toNumber(0),
      distanceTraveledWithCurrentFuel: this.toNumber(0),
      fuelEfficiency: this.toNumber(0),
      fuelCostPerUnit: this.toNumber(0),
      refuelRecords: [],
      powerVoltage: this.toNumber(IOs['acv'] || IOs['extPower'] || IOs['accv']),
      batteryVoltage: this.toNumber(
        IOs['acv'] || IOs['extPower'] || IOs['accv']
      ),
      batteryLevel: this.toNumber(0),
      nameDriverTrama: this.toString(data.namedriver),
    };
    let device: Device = this.toDevice(data, IOs);
    unit.GNSSIMEI = device.IMEI;
    unit.device = device;
    return unit;
  }
  public toDevice(data: any, IOs: IOs): Device {
    let device: Device = {
      IMEI: this.toString(data.IMEI),
      deviceName: this.toString(IOs['type']),
      IOs: IOs,
      lastStartTime: new Date(),
      satelliteCount: this.toNumber(IOs['sat']),
      powerVoltage: this.toNumber(IOs['acv'] || IOs['extPower'] || IOs['accv']),
      batteryVoltage: this.toNumber(IOs['bat'] || IOs['internalBatteryPower']),
      batteryLevel: this.toNumber(0),
      latitude: this.toNumber(data.latitud),
      longitude: this.toNumber(data.longitud),
      altitude: this.toNumber(data.altitud),
      speed: this.toNumber(0),
      angle: this.toNumber(data.angulo),
      signalStrength: 0,
      serverDate: new Date(this.toISO(data.dt_server ?? '')),
      trackerDate: new Date(this.toISO(data.dt_tracker ?? '')),
      sentRecordsCount: 0,
      actualOperatorCode: 0,
      signalLevel: 0,
      GPRSStatus: false,
      SIMStatus: false,
      SIMNumber: this.toNumber(data.sim_number),
    };
    if (IOs['hdop']) device.HDOP = this.toNumber(IOs['hdop']);
    if (IOs['pdop']) device.PDOP = this.toNumber(IOs['pdop']);
    return device;
  }
  public frameToDevice(data: any): Device {
    let IOs = this.parseParams(data['Parametros']);
    let device: Device = {
      IMEI: data['IMEI'],
      deviceName: this.toString(IOs['type']),
      IOs: IOs,
      lastStartTime: new Date(),
      satelliteCount: this.toNumber(IOs['sat']),
      powerVoltage: this.toFloat(IOs['acv'] || IOs['extPower'] || IOs['accv']),
      batteryVoltage: this.toFloat(IOs['bat'] || IOs['internalBatteryPower']),
      batteryLevel: this.toNumber(0),
      latitude: this.toFloat(data['Latitud']),
      longitude: this.toFloat(data['Longitud']),
      altitude: this.toFloat(data['Altitud']),
      speed: this.checkSpeed(IOs) || this.toNumber(data['Velocidad']),
      angle: this.toFloat(data['Angulo']),
      signalStrength: this.toNumber(0),
      serverDate: new Date(this.toISO(data['fecha_server'] ?? '')),
      trackerDate: new Date(this.toISO(data['fecha_tracker'] ?? '')),
      sentRecordsCount: this.toNumber(data['record']),
      actualOperatorCode: this.toNumber(data['']),
      signalLevel: this.toNumber(data['']),
      GPRSStatus: false,
      SIMStatus: false,
      SIMNumber: 0,
    };
    return device;
  }
  private updateUnit(frame: Device, units: Unit[]): Device {
    const unit = units.find((_) => _.GNSSIMEI == frame.IMEI);
    if (unit) {
      if (unit.device.trackerDate < frame.trackerDate) {
        frame.SIMNumber = this.toNumber(unit.device.SIMNumber);
        unit.locationDate = this.checkPosition(unit.device, frame);
        unit.device = { ...unit.device, ...frame };
        unit.currentSpeed = frame.speed;
        unit.latlngTimeElapsed = this.getElapsedTimeByDate(unit.locationDate);
        unit.hasIgnition = unit.GNSSIMEI.toString().startsWith('E')
          ? this.checkIgnitionForCipia(
              (frame.IOs['event'] ?? '').toString(),
              unit.hasIgnition,
              unit.currentSpeed
            )
          : this.checkIgnition(frame.IOs);
        unit.elapsedTime = this.getElapsedTime(frame.trackerDate.toISOString());
        this.unit$.next(unit);
      }
    }
    return frame;
  }
  private filteredUnits(frames: Device[]): Device[] {
    const imeiSet = new Set();
    return frames
      .sort((a, b) => b.trackerDate.getTime() - a.trackerDate.getTime())
      .filter((_) => {
        if (_.IMEI.toString().startsWith('E')) {
          return true;
        }
        if (!imeiSet.has(_.IMEI)) {
          imeiSet.add(_.IMEI);
          return true;
        }
        return false;
      });
  }
  private updateUnits(frames: Device[], units: Unit[]): Device[] {
    const fltUnits = this.filteredUnits(frames);
    const _units = [...units];
    fltUnits.map((fltUnit) => {
      const _unit = _units.find((unit) => unit.GNSSIMEI == fltUnit.IMEI);
      if (_unit) {
        if (_unit.GNSSIMEI.startsWith('E'))
          _unit.hasIgnition = this.checkIgnitionForCipia(
            (_unit.device.IOs['event'] ?? '').toString(),
            _unit.hasIgnition,
            _unit.currentSpeed
          );
        if (_unit.device.trackerDate < fltUnit.trackerDate) {
          fltUnit.SIMNumber = this.toNumber(_unit.device.SIMNumber);
          _unit.locationDate = this.checkPosition(_unit.device, fltUnit);
          _unit.device = { ..._unit.device, ...fltUnit };
          _unit.currentSpeed = fltUnit.speed;
          if (!_unit.GNSSIMEI.startsWith('E'))
            _unit.hasIgnition = this.checkIgnition(fltUnit.IOs);
        }
      }
    });
    _units.map(
      (unit) => (
        (unit.elapsedTime = this.getElapsedTimeByDate(unit.device.trackerDate)),
        (unit.latlngTimeElapsed = this.getElapsedTimeByDate(unit.locationDate))
      )
    );
    this.units$.next(_units.map((_) => ({ ..._ })));
    return fltUnits;
  }
  public latestDevicesInformation(frames: Device[]): Device[] {
    const _frames = new Map<string, Device>();
    frames.map((frame) => {
      const _frame = _frames.get(frame.IMEI);
      if (!_frame || frame.trackerDate > _frame.trackerDate)
        _frames.set(frame.IMEI, frame);
    });
    return Array.from(_frames.values());
  }
  private generateUUIDv1(): string {
    const now = Date.now();
    const timestamp = now.toString(16).padStart(12, '0');
    const clockSeq = Math.floor(Math.random() * 0x3fff);

    const timeLow = timestamp.substring(4);
    const timeMid = timestamp.substring(0, 4);
    const timeHiAndVersion = (
      (parseInt(timestamp.substring(0, 3), 16) & 0x0fff) |
      0x1000
    ).toString(16);

    const clockSeqHiAndReserved = (((clockSeq >> 8) & 0x3f) | 0x80)
      .toString(16)
      .padStart(2, '0');
    const clockSeqLow = (clockSeq & 0xff).toString(16).padStart(2, '0');

    const node = this.generatePseudoNode();
    return `v1_${timeLow}-${timeMid}-${timeHiAndVersion}-${clockSeqHiAndReserved}${clockSeqLow}-${node}`;
  }
  private generatePseudoNode(): string {
    const data = [
      navigator.userAgent ?? '-',
      navigator.language ?? '-',
      navigator.appCodeName ?? '-',
      navigator.vendor ?? '-',
      navigator.platform ?? '-',
      navigator.productSub ?? '-',
      navigator.hardwareConcurrency ?? '-', //  nucleos
      screen.width ?? '-',
      screen.height ?? '-',
      screen.colorDepth ?? '-',
      Intl.DateTimeFormat().resolvedOptions().timeZone ?? '-',
    ].join('|');

    let hash = 0;
    for (let i = 0; i < data.length; i++) {
      hash = ((hash << 5) - hash + data.charCodeAt(i)) & 0xffffffff;
    }

    const hex = Math.abs(hash).toString(16).padStart(12, '0').substring(0, 12);
    return hex;
  }
  async getLocation(): Promise<{ lat: number; lng: number } | null> {
    const permiso = await navigator.permissions
      .query({
        name: 'geolocation' as PermissionName,
      })
      .catch(() => ({ state: 'denied' } as PermissionStatus));

    if (permiso.state === 'denied') {
      alert(
        'La ubicación está bloqueada. Ve a la configuración del navegador para activarla.'
      );
      return null;
    }

    const posicion = await new Promise<GeolocationPosition | null>(
      (resolve) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => {
            console.error('Error al obtener ubicación:', err.message);
            resolve(null);
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      }
    );

    return posicion
      ? {
          lat: posicion.coords.latitude,
          lng: posicion.coords.longitude,
        }
      : null;
  }
  // -----Helps-----
  private toISO(_: string): string {
    const converted = _.replace(/\//g, '-').replace(' ', 'T');
    return converted.split('.')[0] + '.000Z';
  }
  private toNumber(_: any): number {
    return typeof _ === 'number'
      ? Math.floor(_)
      : parseInt(_ as string, 10) || 0;
  }
  private toString(_: any): string {
    return typeof _ === 'string'
      ? _ === '0' || _ === 'null' || _ === ''
        ? '-'
        : _
      : String(_ || '-') || '-';
  }
  private toBoolean(_: any): boolean {
    return _ === true || _ === 'true' || _ === 1 || _ === '1';
  }
  private toFloat(_: any): number {
    return typeof _ === 'number' ? _ : parseFloat(_ as string) || 0;
  }
  private checkIgnitionForCipia(
    _: string,
    ing: boolean,
    speed: number
  ): boolean {
    const events: Record<string, boolean> = {
      IgnitionON: true,
      IgnitionOFF: false,
    };
    return speed > 3 || (events[_] ?? ing);
  }
  private checkIgnition(_: IOs): boolean {
    return this.toString(_.type) == 'cipia'
      ? this.checkSpeed(_) > 3
      : this.toBoolean(
          _['Custom ignition'] || _['Custom_ign'] || _['di4'] || _['ing'],
        );
  }
  private checkSpeed(_: IOs): number {
    const speed = _['Speed'] || _['speed'] || 0;
    return this.toNumber(
      _['GPS speed'] || this.toNumber(_['can_speed']) == 255
        ? speed
        : _['can_speed'] || speed
    );
  }
  private getElapsedTime(_: string): number {
    const now = new Date();
    const trackerDate = new Date(_);
    return Math.floor((now.getTime() - trackerDate.getTime()) / 1000);
  }
  private getElapsedTimeByDate(_: Date): number {
    const now = new Date();
    return Math.floor((now.getTime() - _.getTime()) / 1000);
  }
  private checkPosition(current: Device, _: Device): Date {
    const distance = L.latLng([current.latitude, current.longitude]).distanceTo(
      L.latLng(_.latitude, _.longitude)
    );
    return distance < 10 ? current.trackerDate : _.trackerDate;
  }
  parseParams(_: any): IOs {
    if (typeof _ !== 'string') return {};
    const [type, ...rest] = _.split('|');
    return rest.reduce(
      (acc, p) => {
        const [key, value] = p.split(/[:=]/).map((str) => str.trim());
        if (key) {
          const _v: number = Number(value);
          acc[key] = value ? (isNaN(_v) ? value : _v) : null;
        }
        return acc;
      },
      { type: type.trim() } as IOs
    );
  }

  public reloadUnits(): void {
    this.requestUnits()
      .pipe(
        first(),
        map((data) => this.toUnits(data)),
        withLatestFrom(this.units$),
        mergeMap(([dbUnits, wsUnits]) =>
          of(this.refreshUnits(dbUnits, wsUnits))
        ),
        tap((units) => {
          this._units = units;
          this.units$.next(units);
        })
      )
      .subscribe();
  }
  private refreshUnits(dbUnits: Unit[], wsUnits: Unit[]): Unit[] {
    return wsUnits.map((wsUnit) => {
      const dbUnit = dbUnits.find((db) => db.GNSSIMEI === wsUnit.GNSSIMEI);
      if (dbUnit) {
        return {
          ...wsUnit,
          idOperation: dbUnit.idOperation,
          operation: dbUnit.operation,
          idGrupo: dbUnit.idGrupo,
          group: dbUnit.group,
          idConvoy: dbUnit.idConvoy,
          convoy: dbUnit.convoy,
          unitName: dbUnit.unitName,
          unitId: dbUnit.unitId,
          isActive: dbUnit.isActive,
        };
      }
      return wsUnit;
    });
  }
}
